import React, { useContext, useEffect, useRef, useState } from "react";
import Add from "../../../Assets/Icons/Add icon.svg";
import Edit from "../../../Assets/Icons/edit.svg";
import Delete from "../../../Assets/Icons/delete.svg";
import CommonFunctions from "../../Shared/CommonFunctions";
import ConsultationService from "../../../Services/ConsultationService";
import { message, Select } from "antd";
import { RxCross2 } from "react-icons/rx";
import { VoiceCommandContext } from "../VoiceCommand/VoiceContext";
import AppointmentService from "../../../Services/AppointmentService";

function Notes({
  patientDiagnosisDetails,
  setPatientDiagnosisDetails,
  appointmentDetails,
  setChiefComplaints,
  chiefComplaints,
  symptomsList,
  setSymptomsList,
  symptoms,
  setSymptoms,
  suggestiveData,
  setSelectedSympObj,
  selectedSymObj,
  setSymptomsCode,
  fetchSuggestionData,
}) {
  const [selectedOption, setSelectedOption] = useState("Primary");
  const [diagnosticList, setDiagnosticList] = useState([]);
  const [selectedCode, setSelectedCode] = useState(null);
  const [suggestiveIcdList, setSuggestiveIcdList] = useState([]);
  const [showMore, setShowMore] = useState(true);
  const [currSympList, setCurrSympList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const fromSuggestionClick = useRef(false);
  const [consultationReasonList, setConsultationReasonList] = useState([]);
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  const {
    chiefComplaintVoice,
    symptomsVoice,
    isListening,
    diseaseConditionVoice,
    icdCodeVoice,
    deleteDiagnosisVoice,
    setDeleteDiagnosisVoice,
    selectAllVoice,
    setSelectAllVoice,
  } = useContext(VoiceCommandContext);

  useEffect(() => {
    if (!deleteDiagnosisVoice) return;

    const lowerVoice = deleteDiagnosisVoice.toLowerCase();

    const matchedDiagnosis = patientDiagnosisDetails.find(
      (diag) =>
        diag?.diagnosisDescription?.toLowerCase().includes(lowerVoice) ||
        diag?.diagnosisCode?.toLowerCase().includes(lowerVoice),
    );

    if (matchedDiagnosis) {
      handleDelete(matchedDiagnosis);
      message.success(
        `Deleted diagnosis: ${matchedDiagnosis.diagnosisDescription}`,
      );
    } else {
      message.error(
        `No matching diagnosis found for: "${deleteDiagnosisVoice}"`,
      );
    }

    setDeleteDiagnosisVoice("");
  }, [deleteDiagnosisVoice]);

  useEffect(() => {
    if (!selectAllVoice) return;

    if (selectAllVoice === "symptoms") {
      handleAllSymptoms(); // ✅ this is already defined
      message.success("✅ All Symptoms Selected");
    }

    if (selectAllVoice === "diagnosis") {
      handleAllIcdSelection(); // ✅ already defined too
      message.success("✅ All Diagnoses Selected");
    }

    setSelectAllVoice(""); // clear after processing
  }, [selectAllVoice]);

  useEffect(() => {
    if (!chiefComplaintVoice) return;

    if (chiefComplaintVoice === "__clear__") {
      setChiefComplaints("");
      return;
    }

    setChiefComplaints((prev) => {
      const prevList = prev
        ? prev
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean)
        : [];

      const incomingList = chiefComplaintVoice
        .toLowerCase()
        .split(/[,;]/)
        .map((s) => {
          const trimmed = s.trim();
          return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
        })
        .filter(Boolean);

      const uniqueNew = incomingList.filter((item) => !prevList.includes(item));

      const combined = [...prevList, ...uniqueNew];

      return combined.join(", ");
    });
  }, [chiefComplaintVoice]);

  useEffect(() => {
    if (!symptomsVoice) return;
    if (symptomsVoice.toLowerCase().includes("select all")) return;
    if (symptomsVoice === "__clear__") {
      setSymptoms("");
      return;
    }

    setSymptoms((prev) => {
      const prevSymptoms = prev ? prev.split(",").map((s) => s.trim()) : [];

      const newOnes = symptomsVoice
        .toLowerCase()
        .split(",")
        .map((s) => {
          const trimmed = s.trim();
          return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
        })
        .filter((s) => s && !prevSymptoms.includes(s));

      const combined = [...prevSymptoms, ...newOnes];

      return combined.join(", ");
    });
  }, [symptomsVoice]);

  useEffect(() => {
    if (fromSuggestionClick.current && selectedCode) {
      handlepayloadDiagList(selectedCode);
      fromSuggestionClick.current = false;
    }
  }, [selectedCode]);

  useEffect(() => {
    if (symptomsList) {
      if (symptomsList.length > 5) {
        setCurrSympList(symptomsList.slice(0, 5));
        setShowMore(true);
      } else {
        setCurrSympList(symptomsList);
        setShowMore(false);
      }
    }
  }, [symptomsList]);

  useEffect(() => {
    if (diseaseConditionVoice) {
      handleIcdDrescriptionSearch(diseaseConditionVoice);
    }
  }, [diseaseConditionVoice]);

  useEffect(() => {
    if (icdCodeVoice) {
      handleIcdCodeSearch(icdCodeVoice);
    }
  }, [icdCodeVoice]);

  useEffect(() => {
    setSuggestiveIcdList(suggestiveData?.diagnosisIcdMasterList);
  }, [suggestiveData?.diagnosisIcdMasterList]);

  const filteredSympList = currSympList?.filter((symptom) => {
    const sympVal = symptoms === "__clear__" ? "" : symptoms || "";
    const selectedSymptomsArr = sympVal
      .toLowerCase()
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
    return !selectedSymptomsArr.includes(symptom.symptomName.toLowerCase());
  });

  const handleChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleIcdDrescriptionSearch = async (value) => {
    if (value.length > 2) {
      let payload = {
        description: value,
        pageSize: 50,
        status: 1,
      };

      try {
        let result = await ConsultationService.ICDData(payload);
        setDiagnosticList(result.data);
        setIsLoading(false);
        if (result.data.length > 0) {
          // Try matching description
          const diseaseOption = result.data.find((item) =>
            item.description
              .toLowerCase()
              .includes(diseaseConditionVoice.toLowerCase()),
          );
          if (diseaseOption && isListening) {
            setSelectedCode(diseaseOption);
            message.success(
              `Disease Condition set: ${diseaseOption.description}`,
            );
          }
        }
      } catch (error) {
        setDiagnosticList([]);
        console.error(error);
        setIsLoading(false);
      }
    }
  };

  const handleIcdCodeSearch = async (value) => {
    if (value.length > 2) {
      let payload = {
        code: value,
        pageSize: 50,
        status: 1,
      };

      try {
        let result = await ConsultationService.ICDData(payload);
        setDiagnosticList(result.data);
        setIsLoading(false);
        if (result.data.length > 0) {
          // Try matching code
          const codeOption = result.data.find(
            (item) => item.code.toLowerCase() === icdCodeVoice.toLowerCase(),
          );
          if (codeOption && isListening) {
            setSelectedCode(codeOption);
            message.success(`ICD Code set: ${codeOption.code}`);
          }
        }
      } catch (error) {
        setDiagnosticList([]);
        console.error(error);
        setIsLoading(false);
      }
    }
  };

  const handleDiagVal = async (value) => {
    setSelectedCode(value);
  };

  const handleDiagKeyDown = (e, diag) => { };

  const handlepayloadDiagList = (codeItem) => {
    if (!codeItem) {
      message.error("Select Diagnosis Details");
      return;
    }
    const isAlreadyPresent = patientDiagnosisDetails?.some(
      (diag) => diag.code === codeItem.code,
    );

    if (isAlreadyPresent) {
      message.error("Diagnosis is already present");
      return;
    }

    let payload = {
      id: codeItem.id,
      code: codeItem.code,
      type: codeItem.type,
      description: codeItem.description,
      status: 1,
      createdDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss",
      ),
      modifiedDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss",
      ),
      createdBy: appointmentDetails.userId,
      modifiedBy: appointmentDetails.userId,
      diagnosisType: selectedOption,
      diagnosisCode: codeItem.code,
      diagnosisDescription: codeItem.description,
      account_Id: appointmentDetails.account_Id,
      clinic_Id: appointmentDetails.clinic_Id,
      patientId: appointmentDetails.patientId,
      userId: appointmentDetails.userId,
    };
    setPatientDiagnosisDetails((prevData) => [...prevData, payload]);
    setSelectedCode(null);
    message.success(`Diagnosis Added: ${payload.description}`);
  };

  const handleDelete = (diagnosis) => {
    if (appointmentDetails.status == 2) {
      setPatientDiagnosisDetails((prevData) =>
        prevData.map((item) =>
          item.diagnosisCode === diagnosis.diagnosisCode
            ? { ...item, status: 0 }
            : item,
        ),
      );
    } else {
      setPatientDiagnosisDetails((prevData) =>
        prevData.filter(
          (item) => item.diagnosisCode !== diagnosis.diagnosisCode,
        ),
      );
    }
  };

  const handleSymChange = (value) => {
    if (value) {
      const selectedSymp = symptomsList.find(
        (item) => item.symptomName === value,
      );
      setSelectedSympObj(selectedSymp);
      setSymptoms(selectedSymp.symptomName);
    } else {
      setSelectedSympObj(null);
      setSymptoms("");
    }
  };

  const handleSelectSuggIcd = (IcdObj) => {
    fromSuggestionClick.current = true;
    setSelectedCode({
      description: IcdObj.icdDisease,
      code: IcdObj.icdCode,
    });
    setSuggestiveIcdList((prevState) => {
      if (prevState) {
        return prevState.filter((item) => item.id !== IcdObj.id);
      }
      return prevState;
    });
  };

  const handleSuggDelete = (e, IcdObj) => {
    e.stopPropagation();
    setSuggestiveIcdList((prevState) => {
      if (prevState) {
        return prevState.filter((item) => item.id !== IcdObj.id);
      }
      return prevState;
    });
  };

  const handleAllIcdSelection = () => {
    for (const item of suggestiveIcdList) {
      const icdObj = {
        description: item.icdDisease,
        code: item.icdCode,
      };
      handlepayloadDiagList(icdObj);
    }
    setSuggestiveIcdList([]);
  };

  const handleSelectSymptom = (symptom) => {
    setSymptoms((prevState) =>
      prevState ? prevState + "," + symptom.symptomName : symptom.symptomName,
    );
    setSymptomsCode((prevState) => [...prevState, symptom.symptomCode]);
    setCurrSympList((prevState) => {
      if (prevState) {
        return prevState.filter((item) => item.id !== symptom.id);
      }
      return prevState;
    });
  };

  const handleSymptomDelete = (e, symptom) => {
    e.stopPropagation();
    setCurrSympList((prevState) => {
      if (prevState) {
        return prevState.filter((item) => item.id !== symptom.id);
      }
      return prevState;
    });
  };

  const handleViewSymptoms = (type) => {
    setShowMore(!showMore);
    if (type === "all") {
      setCurrSympList(symptomsList);
    } else if (type === "less") {
      const minItems = [...symptomsList];
      if (minItems.length > 5) setCurrSympList(minItems.slice(0, 5));
    }
  };

  const handleAllSymptoms = () => {
    const sympStr = filteredSympList.map((sym) => sym.symptomName).join(",");
    setSymptoms((prevState) =>
      prevState ? prevState + "," + sympStr : sympStr,
    );
    setCurrSympList([]);
  };

  const fetchConsReasons = async (filterPayload) => {
    const payload = {
      chiefComplaint: "",
      status: 1,
    };
    let finalPayload;
    if (filterPayload) {
      finalPayload = {
        ...payload,
        ...filterPayload,
      };
    }
    try {
      const response = await AppointmentService.AllConsReasons(finalPayload);
      setConsultationReasonList(response.data || []);
    } catch (e) {
      console.error(e);
    }
  };

  const handleChiefComplaintsSearch = (value) => {
    if (value && value.length >= 3) {
      const payload = {
        chiefComplaint: value,
      };
      fetchConsReasons(payload);
    }
  };

  const handleConsSelectChange = (reason) => {
    let payload = {
      complaintCode: reason.complaintCode,
    };
    fetchSuggestionData(payload);
    setChiefComplaints(reason.chiefComplaint);
    setConsultationReasonList([]);
  };

  return (
    <div className="">
      <div className="h-[270px] overflow-y-scroll">
        <div className="flex w-full gap-5 p-3 mt-2">
          <div className="flex flex-col space-y-2 w-full relative">
            <input
              type="text"
              id="chiefComplaint"
              name="chiefComplaint"
              placeholder=""
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans peer  focus:border-[#189FAA] text-[#333] bg-transparent"
              value={chiefComplaints === "__clear__" ? "" : chiefComplaints}
              onChange={(e) => {
                setChiefComplaints(e.target.value);
                handleChiefComplaintsSearch(e.target.value);
              }}
            />
            {consultationReasonList.length > 0 && (
              <ul className="absolute  top-10 left-0 w-[100%] mt-1 bg-white border rounded-md shadow-md max-h-20 overflow-y-auto z-20">
                {consultationReasonList.map((reason, index) => (
                  <li
                    onClick={() => handleConsSelectChange(reason)}
                    key={index}
                    className="px-2 py-2 text-[13px] font-sans hover:bg-gray-200 cursor-pointer"
                  >
                    {reason.chiefComplaint}
                  </li>
                ))}
              </ul>
            )}
            <label
              htmlFor="chiefComplaint"
              className="text-xs font-medium font-sans text-[#333333] absolute left-2 -top-4 transition-all peer-placeholder-shown:top-0 peer-placeholder-shown:text-xs peer-placeholder-shown:text-[#959595] peer-focus:-top-4 peer-focus:text-[#189FAA] peer-focus:text-xs bg-white px-1"
            >
              Chief Complaint
            </label>
          </div>
          <div className="w-full">
            <div className="flex flex-col space-y-2 w-full relative">
              {/* {
              (symptomsList && symptomsList?.length > 0) ?
                (
                  <Select
                    showSearch
                    placeholder="Select Symptom"
                    onChange={handleSymChange}
                    className="w-full"
                    options={symptomsList?.map((symptom, idx) => {
                      return {
                        label: symptom.symptomName,
                        value: symptom.symptomName,
                        key: idx
                      };
                    })}
                    filterOption={(input, option) =>
                      option &&
                      option.label &&
                      option.label.toUpperCase().indexOf(input.toUpperCase()) >= 0
                    }
                    allowClear
                  />
                )
                :
                ( */}
              <input
                type="text"
                id="chiefComplaint"
                name="chiefComplaint"
                placeholder=""
                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans peer  focus:border-[#189FAA] text-[#333] bg-transparent"
                value={symptoms === "__clear__" ? "" : symptoms}
                onChange={(e) => setSymptoms(e.target.value)}
              />
              {/* )
            } */}
              <label
                htmlFor="Symptoms"
                className="text-xs font-medium font-sans text-[#333333] absolute left-2 -top-4 transition-all peer-placeholder-shown:top-0 peer-placeholder-shown:text-xs 
              peer-placeholder-shown:text-[#959595] peer-focus:-top-4 peer-focus:text-[#189FAA] peer-focus:text-[10px] bg-white px-1"
              >
                Symptoms
              </label>
            </div>
            <div className="flex flex-wrap gap-1 my-1">
              {filteredSympList &&
                filteredSympList?.map((symptom, idx) => (
                  <div
                    key={idx}
                    className="flex items-center gap-1 cursor-pointer"
                    onClick={() => handleSelectSymptom(symptom)}
                  >
                    <div className="p-1 rounded-lg bg-brand-primaryColor text-white text-xs flex items-center gap-1">
                      <p className="m-0.5 p-0.5">{symptom.symptomName}</p>
                      <RxCross2
                        onClick={(e) => handleSymptomDelete(e, symptom)}
                        className="text-xl rounded-[100%] p-1 border border-brand-lightBg"
                      />
                    </div>
                  </div>
                ))}
              {symptomsList.length > 5 &&
                (showMore ? (
                  <div
                    className="w-7 h-7 rounded-full bg-brand-primaryColor text-white flex items-center justify-center text-xl cursor-pointer"
                    onClick={() => handleViewSymptoms("all")}
                  >
                    +
                  </div>
                ) : (
                  <div
                    className="w-7 h-7 rounded-full bg-brand-primaryColor text-white flex items-center justify-center text-xl cursor-pointer"
                    onClick={() => handleViewSymptoms("less")}
                  >
                    -
                  </div>
                ))}
              {filteredSympList && filteredSympList.length !== 0 && (
                <div
                  className="text-sm underline p-1 text-[#189FAA] text-center cursor-pointer"
                  onClick={handleAllSymptoms}
                >
                  Select All
                </div>
              )}
            </div>
          </div>
        </div>
        <hr className="border mt-1" />
        {loggedUser.user.isIcd10Code === "Y" && (
          <div className="flex w-full gap-2 p-3">
            <h2 className="text-sm mt-6 font-semibold font-sans text-[#333333]">
              Diagnosis
            </h2>
            <div className="flex space-x-4">
              <label className="flex items-center space-x-2 text-gray-700">
                <input
                  type="radio"
                  id="Primary"
                  name="options"
                  value="Primary"
                  checked={selectedOption === "Primary"}
                  onChange={handleChange}
                  className="w-4 h-4 text-[#189FAA] focus:ring-blue-500"
                />
                <span className="text-xs text-[#333333] font-sans font-medium">
                  Primary
                </span>
              </label>
              <label className="flex items-center space-x-2 text-gray-700">
                <input
                  type="radio"
                  id="Secondary"
                  name="options"
                  value="Secondary"
                  checked={selectedOption === "Secondary"}
                  onChange={handleChange}
                  className="w-4 h-4 text-[#189FAA] focus:ring-[#189FAA]"
                />
                <span className="text-xs text-[#333333] font-sans font-medium">
                  Secondary
                </span>
              </label>
            </div>
            <div className="flex justify-center items-center w-full gap-3 p-3">
              <div className="flex flex-col space-y-2 w-1/2">
                <label
                  htmlFor="Disease Condition"
                  className="text-sm font-medium font-sans text-[#333333] "
                >
                  {/* Disease Condition */}
                </label>
                {/* <input
              type="text"
              id="chiefComplaint"
              name="chiefComplaint"
              placeholder="Select Disease Condition"
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#959595]"
            /> */}
                <Select
                  showSearch
                  placeholder="Disease Condition"
                  className="h-10 w-full mt-2"
                  onSearch={handleIcdDrescriptionSearch}
                  onChange={(value, option) => handleDiagVal(option?.data)}
                  value={selectedCode?.description || undefined}
                  options={diagnosticList?.map((des) => {
                    return {
                      label: des.description,
                      value: des.code,
                      data: des,
                    };
                  })}
                  filterOption={(input, option) =>
                    option &&
                    option.label &&
                    option.label.toUpperCase().indexOf(input.toUpperCase()) >= 0
                  }
                  allowClear
                  notFoundContent={null}
                  onKeyDown={(e) => handleDiagKeyDown(e, "Primary")}
                />
              </div>
              <div className="flex flex-col space-y-2 w-1/2">
                <label
                  htmlFor="Disease Condition"
                  className="text-sm font-medium font-sans text-[#333333]"
                >
                  {/* ICD - 10 Code */}
                </label>
                {/* <input
              type="text"
              id="chiefComplaint"
              name="chiefComplaint"
              placeholder="Select ICD Code"
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#959595]"
            /> */}
                <Select
                  showSearch
                  placeholder="ICD Code"
                  className="h-10 w-full mt-2"
                  onSearch={handleIcdCodeSearch}
                  onChange={(value, option) => handleDiagVal(option.data)}
                  value={selectedCode?.code || undefined}
                  options={diagnosticList?.map((des) => {
                    return {
                      label: des.code,
                      value: des.code,
                      data: des,
                    };
                  })}
                  filterOption={(input, option) =>
                    option &&
                    option.label &&
                    option.label.toUpperCase().indexOf(input.toUpperCase()) >= 0
                  }
                  allowClear
                  notFoundContent={null}
                  onKeyDown={(e) => handleDiagKeyDown(e, "Primary")}
                />
              </div>
              <img
                src={Add}
                id="addDiagnosisBtn"
                alt=""
                className="w-7 h-7  cursor-pointer"
                role="button"
                onClick={() => handlepayloadDiagList(selectedCode)}
              />
            </div>
          </div>
        )}
        <div className="flex items-center gap-2 flex-wrap">
          {suggestiveIcdList &&
            suggestiveIcdList?.map((Icd, idx) => (
              <div
                key={idx}
                className="flex items-center gap-1 cursor-pointer"
                onClick={() => handleSelectSuggIcd(Icd)}
              >
                <div className="p-1 rounded-lg bg-brand-primaryColor text-white text-xs flex items-center gap-1">
                  <p className="m-0.5 p-0.5">{`${Icd.icdDisease} - ${Icd.icdCode}`}</p>
                  <RxCross2
                    onClick={(e) => handleSuggDelete(e, Icd)}
                    className="text-xl rounded-[100%] p-1 border border-brand-lightBg"
                  />
                </div>
              </div>
            ))}

          {suggestiveIcdList && suggestiveIcdList.length !== 0 && (
            <div
              className="text-sm underline p-1 text-[#189FAA] text-center cursor-pointer"
              onClick={handleAllIcdSelection}
            >
              Select All
            </div>
          )}
        </div>

        {patientDiagnosisDetails && patientDiagnosisDetails.length > 0 && (
          <div className="flex flex-col w-full border border-gray-300 rounded-lg shadow-md p-3">
            <div className="flex w-full bg-[#F5FEFA] text-[#333333] font-sans font-medium text-xs">
              <div className="p-2 border border-[#D2E1E2] text-center w-[15%]">
                Type
              </div>
              <div className="p-2 border border-[#D2E1E2] text-left w-[50%]">
                Disease Condition
              </div>
              <div className="p-2 border border-[#D2E1E2] text-center w-[20%]">
                ICD-10 Code
              </div>
              <div className="p-2 border border-[#D2E1E2] text-center w-[15%]">
                Action
              </div>
            </div>

            {patientDiagnosisDetails && patientDiagnosisDetails.length > 0 && (
              <div className="w-full">
                {patientDiagnosisDetails
                  .filter((diagnosis) => diagnosis?.status !== 0)
                  .map((diagnosis, index) => (
                    <div
                      key={index}
                      className="flex w-full text-[#189FAA] font-sans font-medium text-xs 
                      bg-white hover:bg-gray-100"
                    >
                      <div
                        className={`p-2 border border-gray-300 text-center w-[15%] font-bold text-[#189FAA]`}
                      >
                        {diagnosis.diagnosisType}
                      </div>
                      <div className="p-2 border border-gray-300 text-left w-[50%]">
                        {diagnosis?.diagnosisDescription || "N/A"}
                      </div>

                      <div className="p-2 border border-gray-300 text-center w-[20%]">
                        {diagnosis?.diagnosisCode || "N/A"}
                      </div>

                      <div className="p-2 border flex justify-center items-center gap-3 border-gray-300 text-center w-[15%]">
                        {/* <img
                        src={Edit}
                        alt="Edit"
                        className="w-4 h-4 cursor-pointer"
                      /> */}
                        <img
                          src={Delete}
                          alt="Delete"
                          className="w-4 h-4 cursor-pointer"
                          onClick={() => handleDelete(diagnosis)}
                        />
                      </div>
                    </div>
                  ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Notes;
